// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"MM-z","carouselContainer":"NM-z"};